module.exports = __webpack_public_path__ + "img/googleplay.81c988be.png";